<template>
  <div class="forget__container">
    <img :src="imgSrc" width="100%" height="100%" class="bg__img" alt="" />
    <div class="login">
      <div class="login_box">
        <div class="login__item">
          <div class="login__name">忘记密码</div>
          <el-form :model="forgetForm" :rules="ForgetRules" ref="forgetForm">
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_1.png" alt="" />
              </div>
              <div class="inputed__form">
                <el-form-item prop="mobile">
                  <el-input
                    placeholder="请输入您的身份证号"
                    v-model="forgetForm.mobile"
                    maxlength="18"
                    class="el_iput"
                /></el-form-item>
              </div>
            </div>
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_3.png" alt="" />
              </div>

              <div class="inputed__form code__form">
                <el-form-item prop="passCode">
                  <el-input
                    placeholder="请输入验证码"
                    v-model="forgetForm.passCode"
                    class="el_iput"
                  />
                </el-form-item>
                <div class="yan__code">
                  <el-button
                    class="code__zhi"
                    :disabled="is_disabled"
                    @click="sendCode"
                    >{{ counted }}</el-button
                  >
                </div>
              </div>
            </div>
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_2.png" alt="" />
              </div>

              <div class="inputed__form">
                <el-form-item prop="password">
                  <el-input
                    placeholder="请设置密码"
                    type="password"
                    v-model="forgetForm.password"
                    class="el_iput"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form__item">
              <div class="item__name">
                <img src="../../assets/img/jin_2.png" alt="" />
              </div>

              <div class="inputed__form">
                <el-form-item prop="repassword">
                  <el-input
                    placeholder="请再次输入密码"
                    type="password"
                    v-model="forgetForm.repassword"
                    class="el_iput"
                  />
                </el-form-item>
              </div>
            </div>
            <div class="form__button">
              <el-button class="el__buton" @click="ForgetSubmit('forgetForm')"
                >设置完成</el-button
              >
            </div>
          </el-form>
        </div>
      </div>

      <div class="ww__logp">
        <div class="w sf">
          <div class="img__logo" @click="goHome">
            <!-- <img
              src="../../assets/img/img_12.png"
              class="img_logo_post"
              alt=""
            /> -->
            <h1 class="logg__name">{{ logoName }}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    var validatePass = (rule, value, callback) => { // 验证密码
      var passwordreg = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/
      if (value === '') {
        callback(new Error("请输入密码"));
      } else if (!passwordreg.test(value)) {
        callback(new Error('请输入6-16位的密码，需包含数字、字母'))
      } else {
        if (this.forgetForm.repassword !== '') {
          this.$refs.forgetForm.validateField("repassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.forgetForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkPassCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    var checkMobile = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('帐号不能为空'));
      } else {
        callback();
      }
      // if (!value) {
      //   return callback(new Error('手机号不能为空'));
      // } else {
      //   const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      //   // console.log(reg.test(value));
      //   if (reg.test(value)) {
      //     callback();
      //   } else {
      //     return callback(new Error('请输入正确的手机号'));
      //   }
      // }
    };
    return {
      logoName: this.Public.logo_name,
      bei__img: 'img_11.png',
      imgSrc: this.Public.imgSrc,
      is_disabled: false,
      counted: '获取验证码',
      forgetForm: {
        mobile: '',
        passCode: '',
        password: '',
        repassword: '',
      },
      ForgetRules: {
        mobile: [{ validator: checkMobile, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        repassword: [{ validator: validatePass2, trigger: "blur" }],
        passCode: [{ validator: checkPassCode, trigger: "blur" }]
      }
    }
  },
  created() {

  },
  methods: {
    sendCode() {    //获取验证码
      // console.log(this.forgetForm.mobile);
      if (this.forgetForm.mobile != '') {
        let url = 'lists/getcode', param = {
          mobile: this.forgetForm.mobile
        };
        this.post(url, param).then(res => {
          // console.log(res);
          const TIME_COUNT = 60;
          this.count = TIME_COUNT;
          this.counted = "已发送" + this.count + '秒'
          this.isDisabled = true;
          if (!this.timer) {
            this.code_show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
                this.counted = "已发送" + this.count + '秒';
              } else {
                this.code_show = true;
                this.isDisabled = false;
                clearInterval(this.timer);
                this.counted = '获取验证码'
                this.timer = null;
              }
            }, 1000);
          }
        }).catch(err => {
          // console.log(err);
          this.$message.error(err.msg)
        })

      } else {
        this.$message.error('手机号不能为空')
      }
    },
    ForgetSubmit(formName) {   // 忘记密码
      this.$refs[formName].validate((valid) => {
        // console.log(formName);   // 代表要提交的表单数据 是 LoginForm 对象
        if (valid) {
          // console.log(valid, "valid");
          let url = 'lists/find_pwd',
            param = {
              phone: this.forgetForm.mobile,
              code: this.forgetForm.passCode,
              new_password: this.forgetForm.password,
              re_pwd: this.forgetForm.repassword
            }
          this.post(url, param).then(res => {
            // console.log(res);
            if (res.code == 1) {
              this.$message.success(res.msg)
            }
            clearInterval(this.timer);
            this.counted = '获取验证码'
            this.$router.push({ path: '/login', query: { num: 1 } })
          }).catch(err => {
            // console.log(err);
            this.$message.error(err.msg)
          })
        }
      })
    },
    goHome() {
      this.$router.push('/')
    },
  },
}
</script>

<style lang="less" scoped>
.forget__container {
  width: 100%;
  height: 100%;

  .bg__img {
    width: 100%;
    height: 100%; /**宽高100%是为了图片铺满屏幕 */
    z-index: -1;
    position: absolute;
  }

  .login {
    width: 100%;
    height: 100%;

    .login_box {
      width: 400px;
      height: 520px;
      background-color: #fff;
      border-radius: 10px;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .login__item {
        width: 100%;
        padding: 33px 44px;
        box-sizing: border-box;

        .login__name {
          width: 100%;
          text-align: center;
          font-size: 24px;
          font-family: Source Han Sans CN, Source Han Sans CN-Medium;
          font-weight: 700;
          color: #06121e;
          line-height: 24px;
          margin-bottom: 30px;
        }

        .form__item {
          height: 44px;
          width: 100%;
          display: flex;
          align-items: center;
          border-radius: 22px;
          box-sizing: border-box;
          background: #edf4fd;
          margin-bottom: 26px;
          .item__name {
            width: 100%x;
            padding: 0 8px 0 16px;
            box-sizing: border-box;

            img {
              width: 24px;
              height: 24px;
            }
          }

          .inputed__form {
            flex: 1;
          }
          .code__form {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .yan__code {
              height: 27px;

              .code__zhi {
                width: 86px;
                font-size: 14px;
                font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                font-weight: 400;
                color: #198bf8;
                line-height: 27px;
                text-align: center;
                padding-right: 16px;
                box-sizing: border-box;
              }

              button {
                margin: 0;
                padding: 0;
                border: 0 none;
                background: transparent;
              }
            }
          }
        }

        .form__button {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 70px;

          .el__buton {
            width: 196px;
            height: 40px;
            background: #198bf8;
            border-radius: 20px;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .ww__logp {
      width: 100%;

      .sf {
        position: relative;

        .img__logo {
          width: 100%;
          position: absolute;
          top: 70px;
          z-index: 2;

          .img_logo_post {
            // width: 180px;
            height: 65px;
          }
          .logg__name {
            height: 65px;
            font-size: 44px;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>